module.exports = __webpack_public_path__ + "img/7.03a82909.png";